var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9454 9.58685C12.5092 8.97622 11.7939 8.57495 10.9914 8.57495C10.1888 8.57495 9.47351 8.97622 9.03735 9.58685C8.7582 9.98811 8.58374 10.4766 8.58374 11C8.58374 12.3259 9.66542 13.4076 10.9914 13.4076C12.3173 13.4076 13.399 12.3259 13.399 11C13.399 10.4766 13.2245 9.98811 12.9454 9.58685Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.463 9.60431C14.6375 9.95324 14.7422 10.5115 14.7422 11C14.7422 13.0587 13.0673 14.751 10.9912 14.751C8.91507 14.751 7.2402 13.0762 7.2402 11C7.2402 10.4941 7.34488 9.95324 7.51935 9.60431H5.40833V15.2046C5.40833 15.9374 6.05384 16.5829 6.7866 16.5829H15.1958C15.9285 16.5829 16.5741 15.9374 16.5741 15.2046V9.60431H14.463Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.946 5.73119H13.9222V8.05157H16.2252V6.02778V5.71375L15.946 5.73119Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4695 0.00872803H5.51309C2.4774 0.00872803 0 2.48613 0 5.52181V16.4956C0 19.5139 2.4774 21.9913 5.51309 21.9913H16.4869C19.5226 21.9913 22 19.5139 22 16.4782V5.52181C21.9826 2.48613 19.5052 0.00872803 16.4695 0.00872803ZM17.7954 9.58684V15.2046C17.7954 16.6701 16.6614 17.8041 15.1959 17.8041H6.78668C5.32117 17.8041 4.18715 16.6701 4.18715 15.2046V9.58684V6.7954C4.18715 5.3299 5.32117 4.19588 6.78668 4.19588H15.1959C16.6614 4.19588 17.7954 5.3299 17.7954 6.7954V9.58684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d0108c32.svg";
export { ForwardRef as ReactComponent };